import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardActionArea, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/StaticPageLayout';

const categories = [
  { id: 'manufacturing', name: 'Manufacturing', description: 'Manufacturing and industrial companies in Ethiopia' },
  { id: 'technology', name: 'Technology', description: 'Technology and IT service providers' },
  { id: 'agriculture', name: 'Agriculture', description: 'Agricultural and food processing businesses' },
  { id: 'construction', name: 'Construction', description: 'Construction and real estate companies' },
  { id: 'healthcare', name: 'Healthcare', description: 'Healthcare providers and medical services' },
  { id: 'professional', name: 'Professional Services', description: 'Professional and business services' },
  { id: 'retail', name: 'Retail', description: 'Retail and wholesale businesses' },
  { id: 'hospitality', name: 'Hospitality', description: 'Hotels, restaurants, and tourism services' }
];

const BusinessCategories: React.FC = () => {
  return (
    <StaticPageLayout>
      <Helmet>
        <title>Business Categories | ET-Business Directory</title>
        <meta name="description" content="Browse Ethiopian businesses by category. Find manufacturing, technology, agriculture, construction, healthcare, professional services, retail, and hospitality businesses." />
      </Helmet>
      
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Business Categories
        </Typography>
        
        <Typography variant="body1" paragraph>
          Browse businesses across different sectors in Ethiopia. Click on a category to explore verified businesses.
        </Typography>
        
        <Grid container spacing={3}>
          {categories.map((category) => (
            <Grid item xs={12} sm={6} md={4} key={category.id}>
              <Card>
                <CardActionArea component={RouterLink} to={`/category/${category.id}`}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {category.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {category.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </StaticPageLayout>
  );
};

export default BusinessCategories; 